import { STS_MYACCOUNT_LOGIN_URL, AVT_MYACCOUNT_LOGIN_URL } from "@/constants";

const btnClickUrl = [
  {
    brand: "staysure",
    logoUrl: STS_MYACCOUNT_LOGIN_URL,
  },
  {
    brand: "avanti",
    logoUrl: AVT_MYACCOUNT_LOGIN_URL,
  },
];

export default btnClickUrl;
